import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaUserPlus } from 'react-icons/fa';

const AdminCreateUser = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('owner');
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        '/api/admin/users',
        { name, email, password, role },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/users');
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-[600px]'>
      <h1 className='text-3xl font-bold mb-6 flex items-center'>
        <FaUserPlus className='mr-3' /> Create User
      </h1>
      <form
        onSubmit={handleSubmit}
        className='bg-white p-6 shadow-lg rounded-lg'
      >
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Name
          </label>
          <input
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Email
          </label>
          <input
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Password
          </label>
          <input
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Role
          </label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className='w-full p-3 border rounded'
          >
            <option value='owner'>Owner</option>
            <option value='admin'>Admin</option>
          </select>
        </div>
        <button
          type='submit'
          className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
        >
          Create User
        </button>
      </form>
    </div>
  );
};

export default AdminCreateUser;
